module.exports = __webpack_public_path__ + "static/media/erosgroup.1b767254.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/erosgroup.png
// module id = 49
// module chunks = 0